<mat-chip-set>
  @if (label_status().toLowerCase() === "pending") {
    <wcg-chip
      [type]="WcgChipType.INFO"
      [label]="label_status() | titlecase"
    ></wcg-chip>
  }

  @if (label_status().toLowerCase() === "approved") {
    <wcg-chip
      [type]="WcgChipType.SUCCESS"
      [label]="label_status() | titlecase"
    ></wcg-chip>
  }

  @if (label_status().toLowerCase() === "closed") {
    <wcg-chip
      [type]="WcgChipType.NEUTRAL"
      [label]="
        expired_date()
          ? (label_status() | titlecase) + ' (' + (expired_date() | ermDate) + ')'
          : (label_status() | titlecase)
      "
    >
    </wcg-chip>
  }

  @if (label_status().toLowerCase() === "disapproved") {
    <wcg-chip
      [type]="WcgChipType.CRITICAL"
      [label]="label_status() | titlecase"
    ></wcg-chip>
  }

  @if (label_status().toLowerCase() === "suspended") {
    <wcg-chip
      [type]="WcgChipType.WARNING"
      [label]="label_status() | titlecase"
    ></wcg-chip>
  }
  @if (
    label_status().toLowerCase() !== "pending" &&
    label_status().toLowerCase() !== "approved" &&
    label_status().toLowerCase() !== "closed" &&
    label_status().toLowerCase() !== "disapproved" &&
    label_status().toLowerCase() !== "suspended"
  ) {
    <span>
      {{ label_status() }}
    </span>
  }
</mat-chip-set>
